import { ReactElement } from 'react';

import { Address, Country } from '@dreryk/address-common-api';

import { useFormController } from '@dreryk/react-common';

import { StreetField } from './fields/StreetField';
import { PatientAddressFormBean, PatientAddressFormController } from './PatientAddressForm.types';
import { StyledPatientAddressForm } from './PatientAddressForm.styled';
import { BuildingField } from './fields/BuildingField';
import { FlatField } from './fields/FlatField';
import { TownField } from './fields/TownField';
import { PostcodeField } from './fields/PostcodeField';
import { CountryField } from './fields/CountryField';

type PatientAddressFormChildrenRenderProps = Pick<PatientAddressFormController, 'formState' | 'handleSubmit'>;

type PatientAddressFormProps = {
   children: (renderProps: PatientAddressFormChildrenRenderProps) => ReactElement;
   patientAddress: Address | undefined;
};

export const PatientAddressForm = (props: PatientAddressFormProps): ReactElement => {
   const { register, formState, handleSubmit, watch } = useFormController<PatientAddressFormBean>({
      country: props.patientAddress?.getCountry() ?? Country.DEFAULT,
      street: props.patientAddress?.findStreet() ?? null,
      building: props.patientAddress?.findBuilding() ?? null,
      town: props.patientAddress?.findTown() ?? null,
      postcode: props.patientAddress?.findPostcode() ?? null,
      flat: props.patientAddress?.findFlat() ?? null,
   });
   return (
      <StyledPatientAddressForm noValidate>
         <StreetField register={register} />
         <BuildingField register={register} />
         <FlatField register={register} />
         <TownField register={register} />
         <PostcodeField register={register} watch={watch} />
         <CountryField register={register} />

         {props.children({ handleSubmit: handleSubmit, formState: formState })}
      </StyledPatientAddressForm>
   );
};
